import * as React from 'react';
import { EventName } from '@lit/react';
import { PdsGlobalHeaderDropdownLink as PdsGlobalHeaderDropdownLinkElement } from '@principal/design-system';
import { PdsGlobalHeaderDropdownLinkProps } from '../../built-component-props';
import { createPdsReactComponent } from '../../create-pds-react-component';

export const PdsGlobalHeaderDropdownLink =
  createPdsReactComponent<PdsGlobalHeaderDropdownLinkProps>()({
    tagName: 'pds-global-header-dropdown-link',
    elementClass: PdsGlobalHeaderDropdownLinkElement,
    react: React,
    events: {
      onClick:
        'pds-global-header-dropdown-link-click' as EventName<CustomEvent>,
    },
  });
